@if (content) {
  <section
    class="custom-section section section--{{ content.sectionColor.color }}"
    [class.section--no-btm-padding]="!content.bottomPadding"
    [class.section--offset]="content.offset">

    @if (content.showTopTriangle) {
      <span class="section__top-triangle section__top-triangle--{{ content.sectionColor.color }}"></span>
    }

    <div class="container-md">
      @if (content.witty) {
        <p class="section__witty">
          {{ content.witty }}
        </p>
      }

      @if (content.title) {
        <h2 class="section__title">
          {{ content.title }}
        </h2>
      }

      @if (content.subTitle) {
        <p class="section__sub-title hero-section__sub-title">
          {{ content.subTitle }}
        </p>
      }

      @if (content.description) {
        <div
          class="section__description section__description--no-columns"
          [innerHTML]="content.description | safe:'bypassSecurityTrustHtml'">
        </div>
      }

      @if (content.ctas && content.ctaPosition === sectionCTAPosition.TOP) {
        <div class="custom-section__cta custom-section__cta--top section__cta">
          @for (cta of content.ctas; track cta) {
            <app-cta [cta]="cta" />
          }
        </div>
      }

      <ng-content />

      @if (content.ctas && content.ctaPosition === sectionCTAPosition.BOTTOM) {
        <div class="custom-section__cta custom-section__cta--bottom section__cta">
          @for (cta of content.ctas; track cta) {
            <app-cta [cta]="cta" />
          }
        </div>
      }
    </div>

    <ng-content select="[bottomImageFullWidth]" />
  </section>
}
